<template>
  <div
    class="w-full cursor-pointer px-4 py-2 flex tablet-h:rounded-[10px] tablet-h:p-1.5 tablet-h:pr-2.5"
    :class="classes"
    @click="handleClick"
  >
    <div class="mr-[9px] size-11 shrink-0 p-0.5">
      <div
        class="flex size-full items-center justify-center rounded-full"
        :class="isWarning ? 'bg-yellow-500/15' : 'bg-red-700/10'"
      >
        <AlertIcon
          class="size-5"
          :class="isWarning ? 'text-yellow-600' : 'text-red-700'"
        />
      </div>
    </div>
    <div
      class="text-[14px] leading-[19px] text-gray-800 -mt-1 flex flex-col justify-between"
    >
      <component :is="copy" class="mb-[3px]" />
      <div class="text-[12px] leading-[18px] opacity-60">
        {{ formatDistanceToNowStrict(props.notification.timestamp) }} ago
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  NotificationType,
  type Notification,
} from '@/shared/graphql/legacy/generated'
import { usePaymentAuthentication } from '@/features/billing/composables/usePaymentAuthentication'
import { AlertIcon } from '@dacr/icons'
import { formatDistanceToNowStrict } from 'date-fns'
import { computed, h } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  notification: Notification
}>()

const router = useRouter()
const { authenticatePayment } = usePaymentAuthentication()

const handleClick = async () => {
  if (
    props.notification.type === NotificationType.AccountPaymentRequiresAction
  ) {
    if (await authenticatePayment()) return
  }

  router.push('/settings/billing')
}

const classes = computed(() => ({
  'tablet-h:hover:bg-[#FAFAFA]': props.notification.read,
  'bg-green-700/10': !props.notification.read,
}))

const isWarning = computed(
  () =>
    props.notification.type === NotificationType.AccountPaymentRequiresAction
)

const copy = computed(() => {
  if (props.notification.type === NotificationType.InvoiceOverdue) {
    return h('div', [
      'We were not able to process your payment. ',
      h('span', { class: 'font-medium' }, 'Update your billing information'),
      ' before you lose access to your account.',
    ])
  }

  if (
    props.notification.type === NotificationType.AccountPaymentRequiresAction
  ) {
    return h('div', [
      'Your credit card provider requires you to authenticate your payment. Please ',
      h('span', { class: 'font-medium' }, 'click here'),
      ' to proceeed with authentication.',
    ])
  }

  return null
})
</script>
